import { useEffect, useRef, useState } from "react";
import throttle from "lodash.throttle";

const useScrolledHeader = (delta = 3) => {
  const headerRef = useRef();

  const [hasScrolled, setHasScrolled] = useState(false);
  const [stickMenus, setStickMenus] = useState(false);
  const [navUp, setNavUp] = useState(false);

  useEffect(() => {
    // Hide Header on on scroll down
    let lastScrollTop = 0;

    const scrollListener = throttle(() => {
      const st = document.body.scrollTop || document.documentElement.scrollTop;
      const dh = document.body.scrollHeight || document.documentElement.scrollHeight;
      const wh = window.innerHeight;

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta) return;
      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      const navBar = headerRef.current;

      if (st > lastScrollTop && st > navBar.clientHeight) {
        // Scroll Down
        setNavUp(true);
        setTimeout(() => setHasScrolled(true), 250);
      } else {
        // Scroll Up
        if (st + wh < dh) {
          setNavUp(false);
        }
      }
      lastScrollTop = st;

      if (st === 0) {
        setHasScrolled(false);
      }

      setStickMenus(st > 300);
    }, 250);

    document.addEventListener("scroll", scrollListener);
    return () => document.removeEventListener("scroll", scrollListener);
  }, [delta]);

  return [headerRef, hasScrolled, navUp, stickMenus];
};

export default useScrolledHeader;
